import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { Layout } from './components/Layout';
import { RequireSession } from './components/RequireSession';
import { AdminPage } from './pages/AdminPage';
import { AuthCallbackPage } from './pages/AuthCallbackPage';
import { HomePage } from './pages/HomePage';
import { LoginPage } from './pages/LoginPage';
import { SetPasswordPage } from './pages/SetPasswordPage';

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/auth/callback" element={<AuthCallbackPage />} />
        <Route path="/set-password" element={<SetPasswordPage />} />
        {/*
          Der Homescreen ist vollflaechig (Synthwave-Hintergrund, fixe Stage) und
          bringt seine Topbar selbst mit – deshalb bewusst ohne <Layout>.
          Layout ist der ruhige Rahmen der App-Innenseiten (Design-System §6).
        */}
        <Route
          path="/"
          element={
            <RequireSession>
              <HomePage />
            </RequireSession>
          }
        />
        <Route
          path="/admin"
          element={
            <RequireSession>
              <Layout>
                <AdminPage />
              </Layout>
            </RequireSession>
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
